module.exports = __webpack_public_path__ + "static/media/clientsIcon.7c30a8f5.svg";